<template>
    <div>
        <el-table
            @sort-change="sortChange"
            :data="empresasResponse.empresas"
            style="width: 100%"
            class="p-table"
            stripe
            border
            size="mini"
        >
            <el-table-column
                prop="razaoSocial"
                label="Razão social"
                min-width="80"
                sortable
            >
            </el-table-column>

            <el-table-column
                prop="nomeGrupo"
                label="Grupo"
                min-width="40"
                sortable
            >
            </el-table-column>

            <el-table-column
                prop="codigoLoja"
                label="Código"
                min-width="20"
                sortable
            >
            </el-table-column>

            <el-table-column
                prop="nomeFantasia"
                label="Nome Fantasia"
                min-width="40"
                sortable
            >
            </el-table-column>

            <el-table-column prop="nickname" label="Apelido" min-width="40" width="240" sortable>
                <template slot-scope="scope">
                    <div v-if="editingRow === scope.row && editingColumn === 'nickname'">
                        <el-input size="mini" v-model="scope.row.nickname" @change="saveEdit()"></el-input>
                    </div>
                    <div v-else>
                        {{ scope.row.nickname }}
                        <i class="el-icon-edit-outline edit-inline-cell" @click="editInline(scope.row, 'nickname')"></i>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="m2" label="M²" min-width="20" sortable>
                <template slot-scope="scope">
                    <div v-if="editingRow === scope.row && editingColumn === 'm2'">
                        <el-input size="mini" v-model="scope.row.m2" @change="saveEdit()"></el-input>
                    </div>
                    <div v-else>
                        {{ scope.row.m2 }}
                        <i class="el-icon-edit-outline edit-inline-cell" @click="editInline(scope.row, 'm2')"></i>
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                prop="ativo"
                label="Status"
                width="80"
                sortable
            >
            <template slot-scope="scope">
                <div :class="{ 'text-success': scope.row.ativo, 'text-danger': !scope.row.ativo }">{{ scope.row.ativo ? 'Ativo' : 'Inativo' }}</div>
            </template>
            </el-table-column>
            
            <el-table-column
                prop="cnpj"
                label="Cnpj"
                min-width="40"
            >
            </el-table-column>
            
        </el-table>

        <el-pagination
            v-if="totalDeRegistros > 0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[25, 50, 75, 100]"
            :page-size="filters.pageSize"
            :current-page.sync="filters.page"
            layout="sizes, prev, pager, next"
            background
            class="text-center"
            :total="totalDeRegistros">
    </el-pagination>
    </div>
</template>

<script>

export default {
    name: 'empresasTable',
    props: ['empresasResponse', 'filters'],
    data() {
        return {
            empresaDataModal: '',
            editingRow: null,
            editingColumn: null,
        }
    },
    methods: {
        handleSizeChange(val) {
            this.filters.pageSize = val
            this.filters.page = 1
            this.$emit('modelAlterado', this.filters)
        },
        handleCurrentChange(val) {
            this.filters.page = val
            this.$emit('modelAlterado', this.filters)
        },
        sortChange(val) {
            this.filters.sort = val.prop
            this.filters.order = val.order
            //this.$emit('modelAlterado', this.filters)
        },
        editInline(row, column) {
            this.editingRow = row;
            this.editingColumn = column;
        },
        onEnter() {
            console.log('ENTER')
        },
        async saveEdit() {
            let body = {
                empresaId: this.editingRow._id,
                m2: this.editingRow.m2,
                apelido: this.editingRow.nickname
            };

            // POST PARA EDITAR
            var request = await this.axios.post(this.$urls.EDITAR_EMPRESA, body);

            if (request.status === 202) {
                this.$message.error(request.data.message);

                const apelido =  request.data.apelido;
            
                this.editingRow.nickname = apelido;

                return;
            }
            else if(request.status !== 200) {
                this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
                return;
            }

            // clear
            this.editingRow = null;
            this.editingColumn = null;

            this.$notify({
                type: "success",
                title: 'Empresa Editada',
                dangerouslyUseHTMLString: true,
                message: 'Apelido / M2 atualizados'
            });
        },
    },
    computed: {
        totalDeRegistros(){
            return this.empresasResponse.total
        }
    }
}
</script>

<style lang="scss" scoped>
    .edit-inline-cell {
        float: right;
        cursor: pointer;
        font-size: 15px;
        position: relative;
        top: 4px;
        color: #007bff;
        transition: 0.2s;
        &:hover {
            color: #606266;
        }
    }
    .text-success {
        text-align: center;
        color: #28a745;
    }
    .text-danger {
        text-align: center;
        color: #dc3545;
    }
</style>